import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Create from './create';
import MergeProperties from './merge_properties';
import Modal from 'components/modal';
import Search from './search';

export default function ListingModal({ deal, edgeCrm, show, onClose, onSave }) {
  const [creating, setCreating] = useState();
  const [mergeProject, setMergeProject] = useState(null);
  const [modalSize, setModalSize] = useState(null);

  let modalBody;
  if (creating) {
    modalBody = (
      <Create
        deal={deal}
        onClose={onClose}
        onSave={onSave}
      />
    );
  } else if (mergeProject) {
    modalBody = (
      <MergeProperties
        deal={deal}
        listing={mergeProject.listing}
        project={mergeProject.project}
        setModalSize={setModalSize}
        onClose={onClose}
        onConnect={onSave}
      />
    );
  } else {
    modalBody = (
      <Search
        deal={deal}
        edgeCrm={edgeCrm}
        onClose={onClose}
        onConfirmMerge={setMergeProject}
        onCreateClick={() => setCreating(true)}
        onSave={onSave}
      />
    );
  }

  const reset = () => {
    setCreating(false);
    setMergeProject(null);
    setModalSize(null);
  };

  return (
    <Modal
      show={show}
      size={modalSize}
      onHide={onClose}
      onShow={reset}
    >
      <Modal.Header closeButton>
        Connect Listing
      </Modal.Header>

      {modalBody}
    </Modal>
  );
}

ListingModal.propTypes = {
  deal: PropTypes.object.isRequired,
  edgeCrm: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
